import React from 'react';

import {
  Skeleton, Stack, Typography,
} from '@mui/material';

import ContentCard from '../../../../components/ContentCard';
import Link from '../../../../components/Link';
import { useGetGroupQuery } from '../../../../services/permissions';
import { Header, SelectableRow } from '../../index.styles';

interface GroupRowProps {
  groupId: string,
}

const GroupRow = ({ groupId }: GroupRowProps) => {
  const { data: group, isLoading: isGroupLoading } = useGetGroupQuery({ group: groupId });

  if (isGroupLoading) {
    return (
      <Skeleton variant="rectangular" height={32} />
    );
  }

  return (
    <SelectableRow>
      <Typography variant="body1">
        <Link href={`/admin/groups?id=${groupId}`} color="inherit" underline="none">
          {group?.data.name}
        </Link>
      </Typography>
    </SelectableRow>
  );
};

interface GroupsCardProps {
  groups: string[],
}

const GroupsCard = ({ groups } : GroupsCardProps) => (
  <ContentCard title="Groups">
    {groups && groups.length > 0 ? (
      <Stack direction="column">
        <Header variant="subtitle2">Name</Header>
        <>
          {groups.map((g) => (
            <GroupRow key={g} groupId={g} />
          ))}
        </>
      </Stack>
    ) : (
      <Typography variant="overline">No groups</Typography>
    )}
  </ContentCard>
);

export default GroupsCard;
